import styled from "styled-components";
import { FooterTitleLine } from "./componet/FooterTitleText/FooterTitleTextStyled";

export const FooterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 40px 30px;
  background-color: #03274c;
  color: #ffffff;

  @media (min-width: 744px) {
    padding: 60px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 0 124px;
    padding: 60px 60px 40px;
  }
  @media (min-width: 1440px) {
    padding: 96px 100px;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 0 66px;
    padding: 60px 100px 40px;
    justify-content: center;
  }
`;

export const FooterBlock = styled.div`
  width: 100%;
  padding-bottom: 40px;

  @media (min-width: 744px) {
    width: 250px;
  }
  @media (min-width: 1440px) {
    padding-bottom: 0px;
    width: 260px;
  }
`;

export const FooterDetailBoxWrapper = styled.div`
  display: flex;
  gap: ${(props) => props.gap || "20px"};
  flex-direction: column;
`;

export const FooterText = styled.span`
  font-weight: 300;
  font-size: 18px;
  color: ${(props) => props.fontColor || ""};
  overflow-wrap: break-word;

  @media (min-width: 744px) {
    font-weight: 400;
    font-size: 14px;
  }
`;

export const FooterLink = styled.a`
  font-weight: 300;
  font-size: 18px;
  color: ${(props) => props.fontColor || ""};
  overflow-wrap: break-word;
  color: #ffff;
  text-decoration: none;
  cursor: pointer;

  @media (min-width: 744px) {
    font-weight: 400;
    font-size: 14px;
  }
   :hover {
    color: #0da9ef;
  }
`;

export const FooterMobileAppBoxWrapper = styled.div`
  display: flex;
  gap: 40px;
  flex-direction: column;

  @media (min-width: 428px) {
    flex-direction: row;
  }

  @media (min-width: 744px) {
    flex-direction: column;
    gap: 20px;
  }
`;

export const FooterMobileAppLogoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  cursor: pointer;
`;
export const FooterMobileAppLogo = styled.img`
  src: ${(props) => props.src};
  width: 170px;
  height: 60px;

  @media (min-width: 744px) {
    width: 170px;
    height: 50px;
    object-fit: contain;
  }
`;

export const FooterLineAppLogo = styled(FooterMobileAppLogo)`
  width: 130px;
  height: 130px;

  @media (min-width: 744px) {
    width: 110px;
    height: 110px;
  }
`;
export const FooterListLogo = styled.img`
  src: ${(props) => props.src};
  margin-right: 16px;
  cursor: pointer;
`;

export const FooterSocialCountryWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  @media (min-width: 744px) {
    width: 100%;
  }
  @media (min-width: 1440px) {
    width: 1240px;
  }
`;

export const FooterSocialButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 20px;

  @media (min-width: 744px) {
    justify-content: flex-end;
    width: 100%;
  }
  @media (min-width: 1440px) {
    width: 1240px;
  }
`;

export const FooterButton = styled.div`
  display: flex;
  width: 60px;
  height: 60px;
  justify-content: center;
  align-items: center;
  background: #ffbf3a;
  border-radius: 25px;
  align-self: flex-end;
  cursor: pointer;

  img {
    width: 20px;
  }
`;

export const FooterLine = styled(FooterTitleLine)`
  margin-bottom: 20px;

  @media (min-width: 1440px) {
    width: 1240px;
  }
`;
